import styles from "./auth-page.module.css";
import { useEffect } from "react";
import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { usePaths } from "BEDROCK/paths";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { useCheckout } from "BEDROCK/pages/checkout/checkout-provider";

type AuthContext =
  | "signin"
  | "signup"
  | "confirm"
  | "changePassword"
  | "resetPassword"
  | "confirmResetPassword";

interface AuthPageProps {
  authContext: AuthContext;
}

export const AuthPage = (props: AuthPageProps) => {
  const { addProject: addProjectToCheckout } = useCheckout();
  const { saveGuestProjectToUsersAccount } = useProjectStore();
  const { session, client, signOut } = useAuthContext();
  const { landing, navigateTo } = usePaths();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get("redirect");

    if (redirect) {
      localStorage.setItem("postAuthRedirect", redirect);
    }
  }, []);

  useEffect(() => {
    // Wait for Supabase to handle the session from URL
    client?.auth.getSession().then(() => {
      // Clean up the URL
      if (window.location.hash.includes("access_token")) {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }
    });
  }, []);

  useEffect(() => {
    if (session) {
      const newID = saveGuestProjectToUsersAccount();
      if (newID) {
        addProjectToCheckout(newID);
      }
      const redirect = localStorage.getItem("postAuthRedirect") ?? undefined;
      if (redirect) {
        if (newID) {
          const url = new URL(redirect, window.location.origin);
          const pathParts = url.pathname.split("/");
          pathParts[pathParts.length - 1] = newID;
          url.pathname = pathParts.join("/");

          const newPath = url.pathname + url.search;

          localStorage.removeItem("postAuthRedirect");
          navigateTo(newPath);
        } else {
          localStorage.removeItem("postAuthRedirect");
          navigateTo(redirect);
        }
      } else {
        navigateTo(landing);
      }
    }
  }, [session]);

  if (session) {
    return (
      <div>
        <button onClick={signOut}>Sign out</button>
      </div>
    );
  }
  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <Auth
          supabaseClient={client!}
          providers={["google"]}
          onlyThirdPartyProviders={false}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: "#ff5476", // primary buttons
                  brandAccent: "#ff5476", // hover/focus color
                  inputBorder: "#e5e5e5",
                  inputBackground: "#f7f7f7",
                  messageText: "#21211f",
                  anchorTextColor: "#ff5476",
                },
                radii: {
                  borderRadiusButton: "8px",
                  inputBorderRadius: "6px",
                },
                fontSizes: {
                  baseBodySize: "15px",
                  baseInputSize: "14px",
                },
              },
            },
          }}
        />
      </div>
    </div>
  );
};
